import request from '@/utils/request'

let NotesApi = {

  /*动态列表*/
  list(data) {
    return request._post('/shop/plus.notes.Index/index', data);
},
lists(data) {
    return request._post('/shop/plus.notes.Index/indexs', data);
},
getNotesRecord(data) {
    return request._post('/shop/plus.notes.Index/getNotesRecord', data);
},
getTopicStats(data) {
    return request._post('/shop/plus.notes.Index/getTopicStats', data);
},
getUsers(data) {
    return request._post('/shop/plus.notes.Index/getUsers', data);
},
getUserStats(data) {
    return request._post('/shop/plus.notes.Index/getUserStats', data);
},
getUserStatsById(data) {
    return request._post('/shop/plus.notes.Index/getUserStatsById', data);
},
passCanel(data) {
    return request._post('/shop/plus.notes.Index/passCanel', data);
},
/*添加动态*/
add(data) {
    return request._post('/shop/plus.notes.Index/add', data);
},
/*修改动态*/
edit(data) {
    return request._post('/shop/plus.notes.Index/edit', data);
},
/*删除动态*/
del(data) {
    return request._post('/shop/plus.notes.Index/del', data);
},
/*动态详情*/
detail(data) {
  return request._post('/shop/plus.notes.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.notes.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.notes.Setting/getSetting', data, errorback);
    },

alist(data){
    return request._post('/shop/plus.notes.Index/index', data);
},
/*获取城市*/ 
getCity(data){
    return request._post('/shop/plus.notes.Index/getCity', data);
},
/*获取推流*/ 
getPushList(data){
    return request._post('/shop/plus.notes.Index/getPushList', data);
},
/*新增推流*/ 
addPushNote(data){
    return request._post('/shop/plus.notes.Index/addPushNote', data);
},
/*获取推流任务*/ 
getPushTaskList(data){
    return request._post('/shop/plus.notes.Index/getPushTaskList', data);
},
  /*动态评论列表*/
  getCommentList(data) {
    return request._post('/shop/plus.notes.Index/indexEvl', data);
},
/*删除动态评论*/
delEvl(data) {
    return request._post('/shop/plus.notes.Index/delEvl', data);
},
passCanelE(data) {
    return request._post('/shop/plus.notes.Index/passCanelE', data);
},
  /*分类管理*/
  catList(data) {
    return request._post('/shop/plus.notes.category/index', data);
},
/*分类添加*/
catAdd(data) {
    return request._post('/shop/plus.notes.category/add', data);
},
/*分类删除*/
catDel(data) {
    return request._post('/shop/plus.notes.category/delete', data);
},
/*分类修改*/
catEdit(data) {
    return request._post('/shop/plus.notes.category/edit', data);
},
 /*得到分类图片*/
 cateImage(data) {
    return request._post('/shop/plus.notes.category/image', data);
},
}
export default NotesApi;



// WEBPACK FOOTER //
// ./src/api/notes.js